import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
import appSettings from './settings';

const PRICE_LIST = appSettings.DropDownList.PriceList;
const RADIUS_LIST = appSettings.DropDownList.RadiusList;

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    token: "",
    userName: "",
    tryFree: false,
    advancedReportFormData: {
      name: "",
      email: "",
      reports: [],
    },
    isFreeAcount: true,
    lockedReport: true,
    menuParameter: {
      x: 0,
      y: 0,
      radius: undefined, //object
      industry: undefined,  
      price: undefined, //object
      authorizationType: undefined,
    },
    mapFuncDelegate: {
      funcName: "",
      funcParams: [],
    },
    voucherList: [],
    myReportObj: {
      reportId: undefined,
      isMyReportModalShow: false
    },
    isConfirmedLocation: false,
    isFirstTimeMounted: true,
    showLocationInvalidModal: false,
    showLocationInvalidMessage: "",
    showLocationConfirmModal: false
  },
  plugins: [createPersistedState()],
  mutations: {
    setUser(state, data) {
      //console.log("setUser" + data);
      state.userName = data.UserName;
      state.token = data.Token;
    },
    clearUser(state) {
      //console.log("clearUser");
      state.userName = undefined;
      state.token = undefined;
    },
    setTryFree(state) {
      state.tryFree = true;
    },
    clearTryFree(state) {
      state.tryFree = false;
    },
    set(state, [variable, value]) {
      // console.log(`state`, state, `variable`, variable, `value`, value);
      state[variable] = value;
    },
    clearAdvancedReportFormData(state) {
      state.advancedReportFormData.name = "";
      state.advancedReportFormData.email = "";
      state.advancedReportFormData.reports = [];
    },
    setMapFuncDelegate(state, { funcName, funcParams = undefined }) {
      // console.log(`state`, state, `funcName`, funcName, `funcParams`, funcParams);
      state.mapFuncDelegate = {
        funcName,
        funcParams,
      };
    },
    clearMapFuncDelegate(state) {
      state.mapFuncDelegate = {
        funcName: "",
        funcParams: [],
      };
    },
    resetMenuParameter(state) {
      state.menuParameter = {
        x: "",
        y: "",
        radius:  undefined,
        industry: undefined,
        price: undefined,
        authorizationType: undefined,
      };

      state.isConfirmedLocation = false;
      state.isFirstTimeMounted = true;
      state.showLocationInvalidModal = false;
      state.showLocationConfirmModal = false;
    },
  },
  modules: {},
});

export default store;
